<template>
  <div class="draggable-tree-item">
    <div class="item-content d-flex align-center py-2">
      <v-icon class="drag-handle mr-2" small>mdi-drag</v-icon>
      <v-btn
        v-if="item.children && item.children.length"
        icon
        x-small
        class="mr-1"
        @click.stop="expanded = !expanded"
      >
        <v-icon small>{{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
      </v-btn>
      <span v-else class="mr-4"></span>
      <v-icon v-if="item.children && item.children.length" class="mr-2" small>
        {{ typeListById[item.qiz_typ_id_field]?.typ_icon }}
      </v-icon>
      <span v-if="!item.qiz_visibility" class="text-decoration-line-through">
        {{ item.qiz_name }} {{ item.qiz_description ? '(' + item.qiz_description + ')' : '' }}
      </span>
      <span v-else class="font-weight-medium">
        {{ item.qiz_name }} {{ item.qiz_description ? '(' + item.qiz_description + ')' : '' }}
      </span>
      <v-spacer></v-spacer>
      <v-chip v-show="item.qiz_value" class="ma-1" label color="secondary">{{ item.qiz_value }}</v-chip>
      <v-btn outlined class="ml-2 rounded-xl" :color="item.qiz_visibility ? 'green' : 'grey'" @click="$emit('toggle-state', item)">
        {{ item.qiz_visibility ? 'Désactiver' : 'Activer' }}
      </v-btn>
      <v-btn depressed class="ml-2 rounded-xl" color="amber darken-1" :to="{ name: 'quizzes-edit', params: { qiz_id: item.qiz_id } }">
        <v-icon left class="mr-2">mdi-pencil</v-icon>Editer
      </v-btn>
    </div>
    <draggable
        v-show="expanded"
        :list="item.children"
        :group="{ name: 'quiz-tree', pull: true, put: true }"
        :options="{ handle: '.drag-handle', emptyInsertThreshold: 80 }"
        @change="onChange"
        class="quiz-tree-children pl-6"
        ghost-class="drag-ghost"
      >
      <DraggableTreeItem
        v-for="child in item.children"
        :key="child.qiz_id"
        :item="child"
        :type-list-by-id="typeListById"
        @change="bubbleChange"
        @toggle-state="$emit('toggle-state', $event)"
      />
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'DraggableTreeItem',
  components: { draggable },
  props: {
    item: { type: Object, required: true },
    typeListById: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      expanded: true
    }
  },
  methods: {
    onChange(evt) {
      this.$emit('change', { parent: this.item, event: evt })
    },
    bubbleChange(payload) {
      this.$emit('change', payload)
    }
  }
}
</script>

<style scoped>
.drag-handle {
  cursor: grab;
}
.drag-ghost {
  opacity: 0.5;
  background: #e3f2fd;
}
.quiz-tree-children {
  min-height: 10px;
}
</style>